import {IoStarSharp} from "react-icons/io5";

let className = "p-1 w-8 h-8";

export const markQuestion = {
    title: "Mark",

    options: [

        {
            name: <IoStarSharp className={className} style={{color: "red"}}/>,
            value: '1'
        },
        {
            name: <IoStarSharp className={className} style={{color: "blue"}}/>,
            value: '2'
        },
        {
            name: <IoStarSharp className={className} style={{color: "violet"}}/>,
            value: "3"
        },
        {
            name: <IoStarSharp className={className} style={{color: "purple"}}/>,
            value: "4"
        }, {
            name: <IoStarSharp className={className} style={{color: "green"}}/>,
            value: "5"
        }

    ]
}

export default {
    sorting: {
        title: "Sorting",

        options: [
            {
                name: 'Default',
                value: 'default'
            },
            {
                name: 'New',
                value: 'new'
            },
            {
                name: "Question Number",
                value: "questionNumber"
            },
            {
                name: "Tested",
                value: "tested"
            },


        ]
    },

    difficulty: {
        title: "Difficulty",
        options: [
            {
                name: 'Default',
                value: 'default'
            },
            {
                name: "Easy",
                value: "easy"
            },
            {
                name: "Medium",
                value: "medium"

            },
            {
                name: "Hard",
                value: "hard"
            }
        ]
    },
    practiced: {
        title: "Practiced",
        options: [
            {
                name: 'Default',
                value: 'default'
            },
            {
                name: "Practiced",
                value: "practiced"
            },
            {
                name: "Not Practiced",
                value: "notPracticed"
            }
        ]

    },
    notes: {
        title: "Notes",
        options: [
            {
                name: 'Default',
                value: 'default'
            },
            {
                name: "Notes",
                value: "notes"
            },
            {
                name: "No Notes",
                value: "noNotes"
            }
        ]
    },
    mark: {
        ...markQuestion,
        options: [{
            name: "All",
            value: "all"
        }, ...markQuestion.options]
    }
}
